import { takeEvery, put, call } from "redux-saga/effects"
import { $host, $authHost } from "store/axios"
import {
  actionTypes,
  getAboutUsSuccess,
  getPrivacySuccess,
  getTermsSuccess,
  getTerms,
  getPrivacy,
  getAboutUs,
  resetResourceState
} from "./action"
import { notification } from "antd"

function* getAboutData(action) {
  const { payload } = action
  try {
    const response = yield $authHost.get(`resources/org/about_us/${payload.id}`)
    yield put(getAboutUsSuccess(response.data.data.about_us))
  } catch (error) {
    yield console.error(error)
  }
}

function* getPrivacyData(action) {
  const { payload } = action
  try {
    const response = yield $authHost.get(
      `resources/org/privacy_policy/${payload.id}`
    )
    yield put(getPrivacySuccess(response.data.data.privacy_policy))
  } catch (error) {
    yield console.error(error)

  }
}

function* getTermsData(action) {
  const { payload } = action
  try {
    const response = yield $authHost.get(
      `resources/org/terms_n_conditions/${payload.id}`
    )
    yield put(getTermsSuccess(response.data.data.terms_n_conditions))
  } catch (error) {
    yield console.error(error)
  }
}
// update
function* updateAbout(action) {
  const { payload } = action
  try {
    const response = yield $authHost.post("resources/org/about_us", payload.data)
    if (response.data.code === 200) {
      notification.success({
        message: response.data.message,
        description: response.data.description,
      })
      yield put(getAboutUs({ id: payload.id }))
    }
  } catch (error) {
    if (error.response && error.response.data) {
      const { code, message, description } = error.response.data
      const errorPreview = { code, message, description }
      notification.error({
        message: errorPreview.message,
        description: errorPreview.description,
      })
      yield put(resetResourceState())
    }
  }
}

function* updatePrivacy(action) {
  const { payload } = action
  try {
    const response = yield $authHost.post(
      "resources/org/privacy_policy",
      payload.data
    )
    if (response.data.code === 200) {
      notification.success({
        message: response.data.message,
        description: response.data.description,
      })
      yield put(getPrivacy({ id: payload.id }))
    }
  } catch (error) {
    if (error.response && error.response.data) {
      const { code, message, description } = error.response.data
      const errorPreview = { code, message, description }
      notification.error({
        message: errorPreview.message,
        description: errorPreview.description,
      })
      yield put(resetResourceState())
    }
  }
}

function* updateTerms(action) {
  const { payload } = action
  try {
    const response = yield $authHost.post(
      "resources/org/terms_n_conditions",
      payload.data
    )
    if (response.data.code === 200) {
      notification.success({
        message: response.data.message,
        description: response.data.description,
      })
      yield put(getTerms({ id: payload.id }))
    }
  } catch (error) {
    if (error.response && error.response.data) {
      const { code, message, description } = error.response.data
      const errorPreview = { code, message, description }
      notification.error({
        message: errorPreview.message,
        description: errorPreview.description,
      })
      yield put(resetResourceState())
    }
  }
}

function* resourcesRootSaga() {
  yield takeEvery(actionTypes.GET_ABOUT, getAboutData)
  yield takeEvery(actionTypes.GET_PRIVACY, getPrivacyData)
  yield takeEvery(actionTypes.GET_TERMS, getTermsData)
  //
  yield takeEvery(actionTypes.UPDATE_ABOUT, updateAbout)
  yield takeEvery(actionTypes.UPDATE_PRIVACY, updatePrivacy)
  yield takeEvery(actionTypes.UPDATE_TERM, updateTerms)
}

export default resourcesRootSaga
